import { IPropSchema } from '../repositories/offers-comparison/entities/props/PropSchema';
import { IProp, TProps } from '../types/redux/props';
import { TCompareType } from '../types/compareType';
import { EFieldGroupName, EFieldName } from '../types/field';

export function prepareProps(props: IPropSchema[], compareType: TCompareType): Partial<TProps> {
  return {
    [compareType]: props.map(prop => {
      const preparedProp: IProp = {
        ...prop,
        items: prop.items.map(item => ({ ...item, name: item.name as unknown as EFieldName })),
        name: prop.name as unknown as EFieldGroupName,
      };

      return preparedProp;
    }),
  };
}
